var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartialPayment = function SvgPartialPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46.627 8.79-5.952-1.786-28.174.595.595 48.215 2.38 1.785h31.151V8.79Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.768 50.456H20.435V57.6h33.333zM37.498 7.6H7.142l-2.38 2.38-.596 4.762H37.5V7.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.58 20.044v33.952c0 2.207 1.793 4 4 4m0 0c2.206 0 4-1.793 4-4V50.68h33.587v3.38a3.936 3.936 0 0 1-3.937 3.937H16.58ZM47.053 50.377V11.583a4.38 4.38 0 0 0-4.38-4.38H22.64",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.213 7.202H8.578",
    stroke: "#000",
    strokeWidth: 0.952,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.58 21.551V11.202c0-2.206-1.793-4-4-4-2.206 0-4 1.794-4 4v3.365l8 .08",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.213 44.012H19.991M39.752 44.012v-6.285M34.39 44.012V40.52M29.022 44.012v-10.46M23.674 44.012v-7.905M28.556 15.933H41.65M28.556 20.694H41.65M28.556 26.646H41.65",
    stroke: "#000",
    strokeWidth: 0.952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.382 18.643v-3.824c0-.042.035-.077.077-.077l1.172.001c.042 0 .076.035.076.077l-.004 3.31c0 .052.051.089.101.072l3.736-1.242c.05-.016.1.02.1.073v.78c0 .033-.02.062-.052.072l-3.833 1.302a.077.077 0 0 0-.052.072v.86c0 .053.052.09.102.072l3.747-1.319c.05-.017.102.02.102.073v.805c0 .033-.02.062-.051.072l-3.848 1.329a.077.077 0 0 0-.052.072v4.236c0 .043.035.077.077.076 2.44-.05 4.349-2.487 4.393-4.648 0-.042.035-.076.078-.076h1.348c.044 0 .079.037.076.08-.266 4.482-4.11 6.643-7.217 5.934a.076.076 0 0 1-.06-.074l-.032-5.08a.077.077 0 0 0-.101-.073l-2.2.742a.077.077 0 0 1-.101-.071l-.014-.733c0-.034.02-.063.051-.074l2.33-.823c.03-.011.051-.04.051-.073v-.819a.077.077 0 0 0-.1-.072l-2.25.742a.077.077 0 0 1-.1-.073v-.749c0-.033.02-.062.052-.072l2.347-.808a.077.077 0 0 0 .051-.072Z",
    fill: "#58B847",
    stroke: "#000",
    strokeWidth: 0.5
  })));
};
export default SvgPartialPayment;